module.exports = __webpack_public_path__ + "static/media/pencil.a327d6f5.svg";